import React from 'react';
import Slider from 'react-animated-slider';
import 'react-animated-slider/build/vertical.css';

const content = [
  {
    title: "Crafting Spaces That Inspire",
    description: "Award-winning interior design tailored to your vision",
    button: "Explore Our Work",
    link: "/works",
    image: "./img/Interior4.jpg"
  },
  {
    title: "Where Concept Meets Craft",
    description: "From bold concepts to refined finishes — every detail matters",
    button: "View Services",
    link: "/service",
    image: "./img/Interior3.jpg"
  },
  {
    title: "Your Dream Space Awaits",
    description: "Luxury villas, resorts, hotels & restaurants — designed to perfection",
    button: "Get in Touch",
    link: "/contact",
    image: "./img/Interior1.jpg"
  }
];

export default () => (
  <Slider className="slider-wrapper" autoplay={6000}>
            {content.map((item, index) => (
              <div
                key={index}
                className="slider-content"
                style={{ background: `url('${item.image}') no-repeat center center` }}
              >
                <div className="inner">
                  <h1>{item.title}</h1>
                  <p>{item.description}</p>
                  {item.button && (
                    <button onClick={() => window.open(item.link, "_self")}>
                      <span className="shine"></span>
                      <span>{item.button}</span>
                    </button>
                  )}
                </div>
              </div>
            ))}
        </Slider>
);
